
import AnimatedSection from '../../../components/base/AnimatedSection';

const WA_DUDAS =
  "https://wa.me/5493415779623?text=Hola!%20Tengo%20dudas%20sobre%20la%20Formaci%C3%B3n%20de%20Pergamino%20en%20La%20Usina%20Norte";

export default function QuienesLoDan() {
  const speakers = [
    {
      name: "Cecilia Ribecco",
      role: "Co-Fundadora MenteIA",
      videoId: "9FYNoxksHD8",
    },
    {
      name: "Milton Caballero",
      role: "Fundador de Academia Elevora",
      videoId: "WIHtWfgClg4",
    },
    {
      name: "Federico Poiana",
      role: "Co-Fundador MenteIA",
      videoId: "u6gXU-G3M0Y",
    },
  ];

  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <AnimatedSection animation="fadeUp">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 text-center">
              Quiénes lo dan
            </h2>
            <p className="text-2xl text-gray-300 mb-12 text-center">
              MenteIA, Rosario, Argentina.
            </p>
          </AnimatedSection>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {speakers.map((speaker, index) => (
              <AnimatedSection key={speaker.name} animation="fadeUp" delay={index * 150}>
                <div className="bg-gray-900 rounded-xl p-8 text-center border border-gray-800 h-full">
                  <div className="w-full aspect-square rounded-full mx-auto mb-4 overflow-hidden cursor-pointer relative group">
                    <iframe
                      src={`https://www.youtube.com/embed/${speaker.videoId}?autoplay=1&mute=1&loop=1&playlist=${speaker.videoId}&controls=0&showinfo=0&modestbranding=1&rel=0`}
                      width="100%"
                      height="100%"
                      allow="autoplay; fullscreen"
                      className="w-full h-full object-cover pointer-events-none"
                      title={`Video ${speaker.name}`}
                    ></iframe>
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                      <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-teal-500 text-white px-4 py-2 rounded-lg font-semibold">
                        Ver biografía
                      </div>
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2">
                    {speaker.name}
                  </h3>
                  <p className="text-gray-400">{speaker.role}</p>
                  <button className="mt-4 text-teal-400 hover:text-teal-300 transition-colors font-medium cursor-pointer whitespace-nowrap">
                    Ver biografía completa
                  </button>
                </div>
              </AnimatedSection>
            ))}
          </div>

          <AnimatedSection animation="scaleUp" delay={200}>
            <div className="text-center">
              <a
                href={WA_DUDAS}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 py-4 bg-teal-500 text-white rounded-lg font-semibold text-lg hover:bg-teal-400 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-teal-500/50"
              >
                Hablar por WhatsApp
              </a>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
